module.exports = __webpack_public_path__ + "smartcard_70x70.0b4e5801fc04e6c908d2db6a39cf4e70.png";